import { render } from "./ItemLogbook.vue?vue&type=template&id=528e53b2&scoped=true"
import script from "./ItemLogbook.vue?vue&type=script&lang=js"
export * from "./ItemLogbook.vue?vue&type=script&lang=js"

import "./ItemLogbook.vue?vue&type=style&index=0&id=528e53b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528e53b2"]])

export default __exports__